/**
 * React context that exposes the active project's `AssetClient` to
 * deep descendants — primarily the image leaf editor, which needs to
 * know whether to render the gallery Browse button at all.
 *
 * The provided value is backend-agnostic: free mode mounts a
 * `localAssetClient(config)` (signs S3 requests in the browser); cloud
 * mode mounts a `cloudAssetClient({ baseUrl, orgSlug, originId })`
 * (uses the API's asset proxy). The leaf editor and the gallery don't
 * branch on which one is present — they just call `client.list` and
 * `client.upload`.
 */

import { createContext, useContext } from 'react';

import type { AssetClient } from './asset-origin.js';

const AssetClientContext = createContext<AssetClient | undefined>(undefined);

export const AssetClientProvider = AssetClientContext.Provider;

export function useAssetClient(): AssetClient | undefined {
  return useContext(AssetClientContext);
}
